<template>
  <div>
    <template v-if="dataItem.package_limits[iKey].type === 'number_input'">
      <package-limit-number-input-card :i-key="iKey" />
    </template>
    <template v-if="dataItem.package_limits[iKey].type==='select'">
      <package-limit-select-card :i-key="iKey" />
    </template>
  </div>
</template>
<script>
import PackageLimitSelectCard from '@/views/Admin/Project_packages/PackageLimits/SelectCard.vue'
import PackageLimitNumberInputCard from '@/views/Admin/Project_packages/PackageLimits/NumberInputCard.vue'

export default {
  name: 'LimitValueCard',
  components: { PackageLimitNumberInputCard, PackageLimitSelectCard },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['projectPackages/dataItem']
    },
  },
}
</script>
